/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import './style/closeButton.scss';

import React, {CSSProperties, PureComponent} from 'react';
import {MouseEventHandler} from "react";
import classNames from "classnames";
import {voidFunction} from "../util/controlUtil";
import AwesomeIcon from "../icon/awesomeIcon";

interface Props {
    onClick: MouseEventHandler;
    className?: string;
    disabled?: boolean;
    style?: CSSProperties;
    title?: string;
}

export default class CloseButton extends PureComponent<Props> {
    render = () => {
        const {className, title, disabled, onClick, style} = this.props;
        return (
            <AwesomeIcon name='times' className={classNames('close-button', className)} title={title} style={style}
                         onClick={disabled ? voidFunction : onClick}/>
        )
    }
}